import "moment/locale/pt-br";
import "react-datetime/css/react-datetime.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Flex,
  Input,
  FormControl,
  FormLabel,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { FilterContainer } from "components/Tables/FilterContainer";
import SearchSelect from "components/SearchSelect/SearchSelect";
import { aitBlockService } from "services/aitBlockService";
import { agentsService } from "services/agentsService";
import { equipmentsService } from "services/equipmentsService";

export const AitBlockFilter = (props) => {
  const { t } = useTranslation('common');
  const { onFilter } = props;
  const { isOpen, onToggle } = useDisclosure();
  const [applicability, setApplicability] = useState("");
  const [initialNumber, setInitialNumber] = useState("");
  const [endNumber, setEndNumber] = useState("");
  const [agent, setAgent] = useState("");
  const [equipment, setEquipment] = useState("");
  const [prefix, setPrefix] = useState("");
  const placeholderColor = useColorModeValue("gray.300", "gray.400");
  
  const [applicabilityData, setApplicabilityData] = useState([]);
  const [agentData, setAgentData] = useState([]);
  const [equipmentData, setEquipmentData] = useState([]);

  const onFilterHandler = () => {
    onFilter({
      applicability: applicability,
      initialNumber: initialNumber,
      endNumber: endNumber,
      agent: agent,
      equipment: equipment,
      prefix: prefix
    });
  }

  const onClearHandler = () => {
    setApplicability("");
    setInitialNumber("");
    setEndNumber("");
    setAgent("");
    setEquipment("");
    setPrefix("");

    onFilter({ applicability: null, initialNumber: null, endNumber: null, agent: null, equipment: null, prefix: null });
  }

  useEffect(() => {
    const loadData = async () => {
      try {
        await fetchParametersApplicabilities({});
      } catch (error) {
        console.error(t("system.error.api.loading-data"), error);
      }
    };

    void loadData();
  }, []);

  const fetchParametersApplicabilities = async (params) => {
    const resApplicability = await aitBlockService.getApplicabilities(JSON.stringify({}));
    if (resApplicability) {
      const resApplicabilityFiltered = resApplicability
        .map((obj) => {
          const { _links, ...filtered } = obj;
          return filtered;
        })
        .sort((a, b) => a.id - b.id);
      setApplicabilityData(resApplicabilityFiltered);
      return resApplicabilityFiltered;
    } else {
      console.error(t("system.error.api.unexpected"), res);
      setApplicabilityData([]);
      return [];
    }
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        await fetchParametersAgents({});
      } catch (error) {
        console.error(t("system.error.api.loading-data"), error);
      }
    };

    void loadData();
  }, []);


  useEffect(() => {
    const loadData = async () => {
      try {
        const resAgent = await agentsService.list({ pageSize: 999 });
        setAgentData(resAgent.content);
      } catch (error) {
        console.error(t("system.error.api.loading-data"), error);
      }
    };

    void loadData();
  }, []);

  useEffect(() => {
    const loadData = async () => {
      try {
        await fetchParametersEquipments({});
      } catch (error) {
        console.error(t("system.error.api.loading-data"), error);
      }
    };

    void loadData();
  }, []);

  const fetchParametersEquipments = async (params) => {
    const resEquipment = await equipmentsService.list(JSON.stringify({}));

    if (resEquipment && resEquipment.content) {
      const resEquipmentFiltered = resEquipment.content
        .map((obj) => {
          const { _links, ...filtered } = obj;
          return filtered;
        })
        .sort((a, b) => a.id - b.id);
      setEquipmentData(resEquipmentFiltered);
      return resEquipmentFiltered;
    } else {
      console.error(t("system.error.api.unexpected"), res);
      setEquipmentData([]);
      return [];
    }
  };

  return (
    <FilterContainer
      w='125px'
      fontSize='sm'
      fontWeight='bold'
      variant="light"
      isOpen={isOpen}
      onToggle={onToggle}
      onFilter={onFilterHandler}
      onClear={onClearHandler}
    >
      <Flex w="100%" gap="4" justify="space-between">
        <FormControl>
          <FormLabel>
            {t('settings.ait-block.form.fields.applicability.label')}
          </FormLabel>
          <SearchSelect
            items={applicabilityData}
            name="applicability"
            valueField="nome"
            displayField="descricao"
            placeholder={t('settings.ait-block.form.fields.applicability.placeholder')}
            value={applicability}
            onChange={e => setApplicability(e.currentTarget.value)}
          />
        </FormControl>

        <FormControl>
          <FormLabel>
            {t('settings.ait-block.form.fields.prefix.label')}
          </FormLabel>
          <Input
            name="prefix"
            value={prefix}
            onChange={e => setPrefix(e.currentTarget.value)}
            placeholder={t('settings.ait-block.form.fields.prefix.placeholder')}
            fontSize="sm"
            _placeholder={{ color: placeholderColor, fontSize: "sm" }}
          />
        </FormControl>
      </Flex>

      <Flex w="100%" gap="4" justify="space-between">
        <FormControl w="230px">
          <FormLabel>
            {t('settings.ait-block.form.fields.initial-number.label')}
          </FormLabel>
          <Input
            name="initialNumber"
            type="number"
            value={initialNumber}
            onChange={e => setInitialNumber(e.currentTarget.value)}
            placeholder={t('settings.ait-block.form.fields.initial-number.placeholder')}
            fontSize="sm"
            _placeholder={{ color: placeholderColor, fontSize: "sm" }}
          />
        </FormControl>

        <FormControl w="230px">
          <FormLabel>
            {t('settings.ait-block.form.fields.end-number.label')}
          </FormLabel>
          <Input
            name="endNumber"
            type="number"
            value={endNumber}
            onChange={e => setEndNumber(e.currentTarget.value)}
            placeholder={t('settings.ait-block.form.fields.end-number.placeholder')}
            fontSize="sm"
            _placeholder={{ color: placeholderColor, fontSize: "sm" }}
          />
        </FormControl>
      </Flex>

      <FormControl>
        <FormLabel>
          {t('settings.ait-block.form.fields.agent.label')}
        </FormLabel>
        <SearchSelect
          items={agentData}
          name="agent"
          displayField={["codigo", "nome"]}
          valueField="id"
          placeholder={t('settings.ait-block.form.fields.agent.placeholder')}
          value={agent}
          onChange={e => setAgent(e.currentTarget.value)}
        />
      </FormControl>

      <FormControl>
        <FormLabel>
          {t('settings.ait-block.form.fields.equipment.label')}
        </FormLabel>
        <SearchSelect
          items={equipmentData}
          name="equipment"
          displayField="numero_serie"
          valueField="id"
          placeholder={t('settings.ait-block.form.fields.equipment.placeholder')}
          value={equipment}
          onChange={e => setEquipment(e.currentTarget.value)}
        />
      </FormControl>
    </FilterContainer>
  );
}